// removed by extract-text-webpack-plugin
module.exports = {"membersContainer":"uP9N5Yfw54pB3HGtN1qsI","membersHeading":"_3MyeiqKsmQ1Sj9e3EVll7n"};


//////////////////
// WEBPACK FOOTER
// ./src/componentStyles/MemberList.css
// module id = 365
// module chunks = 0